<div class="document-camera-background">
  <div class="document-camera-wrapper">
    <div class="camera-wrapper" [class.no-image-detection]="imageDetectionAvailable == false">
      <video id="videoInput" autoplay muted playsinline></video>
      <canvas id="canvasOutput"></canvas>
      @if (hinttext) {
        <p class="hint" [innerHTML]="hinttext | translate"></p>
      }
      @if (countdown) {
        <p class="countdown"><span>{{ textprefix + 'camera.countdown' | translate }}</span></p>
      }
      @if (!cameraStarted) {
        <p class="loading">{{textprefix + 'camera.loading' | translate }}</p>
      }
    </div>
    @if (cameraStarted) {
      <div class="button-wrapper">
        <button (click)="close()" class="close">{{textprefix + 'camera.close' | translate }}</button>
        <button (click)="takePicture()" class="take-picture" #takePictureButton [class.loading]="takePhoto">{{textprefix + 'camera.take_picture' | translate }}</button>
      </div>
    }
  </div>
</div>
